import { Link } from "react-router"
import { ImpersonationBanner } from "@/components/layout/impersonation-banner"

export default function UnauthorizedPage() {
  return (
    // The bar matters most here: a denied route is exactly where an admin
    // gets stranded mid-impersonation, and "Return to Dashboard" just bounces
    // back if the impersonated user genuinely lacks the role.
    <div className="flex min-h-screen flex-col bg-zinc-50 safe-area-top">
      <ImpersonationBanner />
      <div className="flex flex-1 items-center justify-center p-4">
        <div className="w-full max-w-md rounded-2xl border border-zinc-200/60 bg-white p-8 shadow-sm">
          <h1 className="text-xl font-bold text-zinc-900 mb-2">Access Denied</h1>
          <p className="text-sm text-zinc-400 mb-6">You do not have permission to access this page.</p>
          <Link to="/dashboard" className="block w-full h-10 rounded-2xl bg-zinc-900 text-white text-sm font-medium hover:bg-black transition-colors duration-100 flex items-center justify-center">
            Return to Dashboard
          </Link>
        </div>
      </div>
    </div>
  )
}
